import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { MultiSectionServant } from '../../views/course_scheduler/servants/multi_section_servant';
import { ISectionSwapToFrom, ISectionSwapModel } from '../models/course_section_swap_model';
import { ISection, ISectionType } from '../../interfaces/scheduler_interfaces';
import { IModel } from 'utility-ts-orm';
import { ITermSectionTypesDatasource } from '../../views/term_courses/datasources/term_section_types_datasource';

angular
  .module('capability-ng-scheduler')
  .service(
    'saveSwapFromSectionCommand',
    function saveSwapFromSectionCommandDefinition(
      $http: ng.IHttpService,
      defineCommandORM: IDefineCommand,
      ngCourseSectionSwapModel: IModel<ISectionSwapModel>,
      ngMultiSectionServant: MultiSectionServant,
      log: any,
      ngTermSectionTypesDatasource: ITermSectionTypesDatasource
    ) {
      'use strict';

      return defineCommandORM(
        'saveSwapFromSectionCommand',
        function saveSwapFromSectionCommand(deferred, fromSection: ISection) {
          const selectedSection: ISectionSwapToFrom = {
            id: fromSection.id,
            section_type: fromSection.section_type
          };

          let from_section: ISectionSwapToFrom[] = [];

          const scheduledSiblings = fromSection
            ? _4.filter(
                ngMultiSectionServant.getScheduledSiblingSectionsOfSameStatus(fromSection) as ISection[],
                (item) => item.id !== fromSection.id
              )
            : [];

          const hasRegisteredMultiSections = !_4.isEmpty(scheduledSiblings);

          let isMultiSection = false;

          if (hasRegisteredMultiSections) {
            isMultiSection = true;
            from_section = _4.compact(
              _4.map(from_section.concat(scheduledSiblings), (item: ISectionSwapToFrom) => {
                return {
                  id: item.id,
                  section_type: item.section_type
                };
              })
            );
          }

          from_section.push(selectedSection);
          const session = _4.get(
            _4.find(
              ngTermSectionTypesDatasource.read(),
              (sectionType: ISectionType) => sectionType.id === fromSection.section_type
            ),
            'session',
            ''
          );
          ngCourseSectionSwapModel.write({
            session,
            course: fromSection.course,
            from_section: selectedSection,
            swap_from_section_ids: from_section,
            isMultiSection
          });

          deferred.resolve(ngCourseSectionSwapModel.read());
        }
      );
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/swap/commands/save_swap_from_section_command.ts